module.exports = (__webpack_require__(926540))(6540);